var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnterFullscreen = function SvgEnterFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    style: {
      transform: "rotate(90deg)"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.552 9.675c.485 0 .854-.349.854-.834v-.356l-.143-1.73 1.25 1.32 1.69 1.71a.841.841 0 0 0 .608.245c.52 0 .888-.369.888-.895a.839.839 0 0 0-.26-.602L7.744 6.838 6.418 5.594l1.75.143h.437c.486 0 .841-.362.841-.854s-.348-.855-.84-.855H5.03c-.847 0-1.34.493-1.34 1.333v3.48c0 .485.37.834.862.834Zm6.843 6.98h3.575c.847 0 1.34-.493 1.34-1.34v-3.473c0-.486-.37-.841-.862-.841-.485 0-.854.349-.854.84v.35l.143 1.729-1.25-1.32-1.69-1.702a.82.82 0 0 0-.607-.252c-.52 0-.89.369-.89.895 0 .232.096.438.26.602l1.696 1.695 1.326 1.244-1.75-.137h-.438c-.485 0-.84.356-.84.848 0 .499.348.861.84.861Z"
  })));
};
export default SvgEnterFullscreen;